import { formatISO } from 'date-fns';

import client from '@/apis/aniftyBackend/client';

const updateCreationReservedAt = async (
  creationID: number,
  newReservedAtInUTC: Date
): Promise<void> => {
  const response = await client.patch(
    `api/creations/${creationID}/reservedAt`,
    {
      reservedAt: formatISO(newReservedAtInUTC),
    }
  );
  return response.data;
};

export default updateCreationReservedAt;
